import {
    Paper,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useMediaQuery,
    useTheme,
} from '@mui/material';

interface Props {
    mobileCardCount?: number;
    tableRowCount?: number;
    tableColumns?: number;
}

const TableSkeleton = ({ mobileCardCount = 4, tableRowCount = 6, tableColumns = 5 }: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    if (isMobile) {
        return (
            <Stack spacing={1.5}>
                {Array.from({ length: mobileCardCount }).map((_, index) => (
                    <Paper key={`mobile-skeleton-${index}`} variant="outlined" sx={{ p: 2 }}>
                        <Stack spacing={1.25}>
                            <Skeleton variant="text" width="48%" height={32} />
                            <Skeleton variant="text" width="72%" />
                            <Stack direction="row" spacing={1}>
                                <Skeleton variant="rounded" width={110} height={24} />
                                <Skeleton variant="rounded" width={124} height={24} />
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Skeleton variant="rounded" width={94} height={24} />
                                <Skeleton variant="rounded" width={88} height={24} />
                            </Stack>
                        </Stack>
                    </Paper>
                ))}
            </Stack>
        );
    }

    return (
        <Paper
            variant="outlined"
            sx={{
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                height: 'clamp(360px, calc(100vh - 290px), 720px)',
                borderRadius: 3,
            }}
        >
            <TableContainer sx={{ overflow: 'auto', flex: 1 }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            {Array.from({ length: tableColumns }).map((_, i) => (
                                <TableCell key={i}>
                                    <Skeleton variant="text" width="60%" />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Array.from({ length: tableRowCount }).map((_, rowIndex) => (
                            <TableRow key={`row-skeleton-${rowIndex}`}>
                                {Array.from({ length: tableColumns }).map((_, colIndex) => (
                                    <TableCell key={colIndex}>
                                        <Skeleton variant="rounded" width="80%" height={24} />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default TableSkeleton;
